export default "/static/build/your-life-mobile.webp";